import { importScreen } from '@infrastructure/splitting';

const ProductSelection = importScreen(() => import('./ProductSelection'));

export { ProductSelection };
